import React from "react";
import { StepShell, EyeResultRow } from "@/components/StepShell";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { NEAR_LINES, NEAR_OPTIONS } from "@/lib/screeningData";
import { useI18n } from "@/i18n";
import { ScanEye } from "lucide-react";

export const NearVisionTest = ({ data, update }) => {
  const { t, tc } = useI18n();
  const n = data.near;
  const nearText = (line) => { const k = "near_" + line.label; const tr = t(k); return tr === k ? line.text : tr; };
  const NearSelect = ({ value, onChange, testId }) => (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full sm:w-48" data-testid={testId}><SelectValue placeholder={t("nv_ph")} /></SelectTrigger>
      <SelectContent>{NEAR_OPTIONS.map((o) => <SelectItem key={o} value={o}>{tc(o)}</SelectItem>)}</SelectContent>
    </Select>
  );
  return (
    <StepShell icon={ScanEye} title={t("nv_title")} subtitle={t("nv_sub")} testId="near-step">
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <div className="bg-white px-6 py-10 flex flex-col items-start gap-5">
          {NEAR_LINES.map((line) => (
            <div key={line.label} className="flex items-baseline gap-4 w-full">
              <span className="w-10 flex-shrink-0 text-xs font-mono text-slate-400 select-none">{line.label}</span>
              <span className="optotype text-black" style={{ fontSize: `${line.size}px`, letterSpacing: "0.02em", fontWeight: 500 }}>{nearText(line)}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-slate-200 bg-slate-50 p-6">
          <p className="text-sm font-semibold text-slate-800 mb-2">{t("nv_record")}</p>
          <div className="divide-y divide-slate-200">
            <EyeResultRow label={t("eye_od")}><NearSelect value={n.od} onChange={(v) => update("near", { od: v })} testId="near-od-select" /></EyeResultRow>
            <EyeResultRow label={t("eye_os")}><NearSelect value={n.os} onChange={(v) => update("near", { os: v })} testId="near-os-select" /></EyeResultRow>
          </div>
          <div className="mt-4 space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("notes")}</Label>
            <Textarea data-testid="near-note-input" rows={2} value={n.note}
              onChange={(e) => update("near", { note: e.target.value })} placeholder={t("notes_ph")} />
          </div>
        </div>
      </div>
    </StepShell>
  );
};
